export { resolveAppShellHomeNav } from './resolveAppShellHomeNav.js'

export function buildAppShellSecondaryNavProps({
  chat,
  handlers,
  homeThreads,
  homePinnedIds,
}) {
  return {
    activeKey: chat.activePrimaryKey,
    onAccountMenuAction: chat.handleAccountMenuAction,
    activeView: chat.activePrimaryKey === 'home' ? chat.homeView : undefined,
    threads: homeThreads,
    selectedThreadId: chat.activePrimaryKey === 'home' ? chat.displayThreadId : null,
    pinnedThreadIds: homePinnedIds,
    onHomeViewChange: chat.setHomeView,
    onThreadSelect: handlers.handleSecondaryThreadSelect,
    onNewChat: handlers.handleSecondaryNewChat,
    onThreadMenuAction: chat.activePrimaryKey === 'home' ? chat.handleThreadMenuAction : undefined,
    onRenameThread: chat.activePrimaryKey === 'home' ? chat.handleRenameThread : undefined,
  }
}
